import { defineComponent as _defineComponent } from 'vue'
import { ObjectType, Offer } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';
import { OfferLocation, trackClickOutGraphql } from '@/helpers/offer-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TitleDetail } from '@/interfaces/title-details-graphql';
// need to import this immediately because it's above the fold and could cause CLS
import BuyBoxOfferNew from '@/components/buybox-new/BuyBoxOfferNew.vue';
// AQTV_TITLEDETAIL_PLACEMENTS
import AQTVTitleDetailPlacements from '@/components/experiments/AQTVTitleDetailPlacememts';
// AQTV_TITLEDETAIL_PLACEMENTS

export default /*#__PURE__*/_defineComponent({
  __name: 'PromotedBuyBoxNew',
  props: {
    promotedOffers: null,
    objectType: null,
    title: null,
    additionalContexts: null,
    appleQualityTvExpActive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	promotedOffers: Offer[];
	objectType: ObjectType;
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
	// AQTV_TITLEDETAIL_PLACEMENTS
	appleQualityTvExpActive?: boolean;
	// AQTV_TITLEDETAIL_PLACEMENTS
};

const { tc } = useI18n();



function clickOut(payload: { buyboxOffer: Offer; isLeavingIconShown: boolean }) {
	trackClickOutGraphql({
		offer: payload.buyboxOffer,
		objectType: props.title.objectType,
		objectId: props.title.objectId,
		offerLocation: OfferLocation.PROMOTED_BUYBOX,
		additionalContexts: props.additionalContexts,
		contentType: undefined,
	});

	// showPageRolloutTracking

	// TITLE_DETAIL_REDESIGN_NEW_BUYBOX
	// const clickoutContext = SnowplowClickoutContextGraphql.fromProviderOffer(payload.buyboxOffer);
	// trackTitleDetailRedesignNewBuyBoxExp({
	// 	action: 'click',
	// 	label: 'clickout',
	// 	contexts: [clickoutContext, ...props.additionalContexts],
	// 	value: OfferLocation.PROMOTED_BUYBOX,
	// });
	// TITLE_DETAIL_REDESIGN_NEW_BUYBOX

	// AQTV_TITLEDETAIL_PLACEMENTS
	if (props.appleQualityTvExpActive) {
		AQTVTitleDetailPlacements.trackEvent({
			action: 'click',
			label: 'clickout',
		});
	}
	// AQTV_TITLEDETAIL_PLACEMENTS
}

return { __sfc: true,tc, props, clickOut, BuyBoxOfferNew }
}

})